/*
 * @Description: 时区映射表
 * @Author: mdb
 * @Date: 2023-03-08 17:32:15
 * @LastEditTime: 2023-03-09 14:47:52
 * @LastEditors: mdb
 */
const timeZoneEnum = [
  { label: 'UTC-12:00 - 贝克岛、豪兰岛', value: 'Etc/GMT+12' },
  { label: 'UTC-11:00 - 中途岛、萨摩亚', value: 'Pacific/Midway' },
  { label: 'UTC-10:00 - 檀香山、阿达克、甘比尔群岛', value: 'Pacific/Honolulu' },
  { label: 'UTC-09:30 - 马克萨斯群岛', value: 'Pacific/Marquesas' },
  { label: 'UTC-09:00 - 安克雷奇、朱诺、洛杉矶、蒂华纳', value: 'America/Anchorage' },
  { label: 'UTC-08:00 - 旧金山、温哥华、西雅图、拉巴斯、马萨特兰', value: 'America/Los_Angeles' },
  { label: 'UTC-07:00 - 丹佛、卡尔加里、华雷斯市、墨西哥城、温尼伯', value: 'America/Denver' },
  { label: 'UTC-06:00 - 芝加哥、墨西哥城、危地马拉城、圣萨尔瓦多', value: 'America/Chicago' },
  { label: 'UTC-05:00 - 纽约、多伦多、哈瓦那、利马、波哥大', value: 'America/New_York' },
  { label: 'UTC-04:00 - 哈利法克斯、圣多明各、马瑙斯、拉巴斯、圣地亚哥', value: 'America/Halifax' },
  { label: 'UTC-03:30 - 圣约翰斯', value: 'America/St_Johns' },
  { label: 'UTC-03:00 - 布宜诺斯艾利斯、圣保罗、蒙得维的亚、圣地亚哥', value: 'America/Argentina/Buenos_Aires' },
  { label: 'UTC-02:00 - 南乔治亚和南桑威奇群岛', value: 'Atlantic/South_Georgia' },
  { label: 'UTC-01:00 - 亚速尔群岛、佛得角群岛', value: 'Atlantic/Cape_Verde' },
  { label: 'UTC+00:00 - 都柏林、伦敦、里斯本、卡萨布兰卡、阿克拉', value: 'Etc/GMT' },
  { label: 'UTC+01:00 - 柏林、巴黎、罗马、马德里、拉各斯', value: 'Europe/Berlin' },
  { label: 'UTC+02:00 - 开罗、约翰内斯堡、基辅、雅典、伊斯坦布尔', value: 'Europe/Kiev' },
  { label: 'UTC+03:00 - 莫斯科、内罗毕、利雅得、巴格达', value: 'Europe/Moscow' },
  { label: 'UTC+03:30 - 德黑兰', value: 'Asia/Tehran' },
  { label: 'UTC+04:00 - 迪拜、巴库、第比利斯、埃里温、萨马拉', value: 'Asia/Dubai' },
  { label: 'UTC+04:30 - 喀布尔', value: 'Asia/Kabul' },
  { label: 'UTC+05:00 - 卡拉奇、塔什干、叶卡捷琳堡', value: 'Asia/Karachi' },
  { label: 'UTC+05:30 - 孟买、加尔各答、金奈、新德里、科伦坡', value: 'Asia/Kolkata' },
  { label: 'UTC+05:45 - 加德满都', value: 'Asia/Kathmandu' },
  { label: 'UTC+06:00 - 阿拉木图、达卡、鄂木斯克、新西伯利亚', value: 'Asia/Almaty' },
  { label: 'UTC+06:30 - 仰光', value: 'Asia/Yangon' },
  { label: 'UTC+07:00 - 曼谷、雅加达、河内、克拉斯诺亚尔斯克', value: 'Asia/Bangkok' },
  { label: 'UTC+08:00 - 北京、香港、马尼拉、珀斯、吉隆坡', value: 'Asia/Shanghai' },
  { label: 'UTC+08:45 - 尤克拉', value: 'Australia/Eucla' },
  { label: 'UTC+09:00 - 东京、首尔、雅库茨克', value: 'Asia/Tokyo' },
  { label: 'UTC+09:30 - 达尔文', value: 'Australia/Darwin' },
  { label: 'UTC+10:00 - 布里斯班、悉尼、关岛', value: 'Australia/Brisbane' },
  { label: 'UTC+10:30 - 劳德赫尔岛', value: 'Australia/Lord_Howe' },
  { label: 'UTC+11:00 - 所罗门群岛、诺福克岛', value: 'Pacific/Guadalcanal' },
  { label: 'UTC+12:00 - 奥克兰、斐济、堪察加、马绍尔群岛', value: 'Pacific/Fiji' },
  { label: 'UTC+13:00 - 努库阿洛法', value: 'Pacific/Fakaofo' },
  { label: 'UTC+14:00 - 基里蒂马蒂', value: 'Pacific/Kiritimati' }
]

export { timeZoneEnum }
